export const menu = {
  api: process.env.VUE_APP_MENU_API_URL,
};
